import React from 'react';
import PropTypes from 'prop-types';
import {
	CouponContainer,
	InputWrapper,
	InputLabel,
	InputRadio,
} from './couponPickerStyles';
import { Toggle } from 'core/hoc';
import { ShowMore } from 'core/styles';

const Coupons = ({ onCouponClick, selectedCouponCode, coupons, visibleWordCount }) => {
	const name = "coupons";
	return (
		<CouponContainer>
			{coupons && coupons.map((option, idx) => {
				const words = option?.display ? option.display.split(' ') : [];
				const hasMore = words.length > visibleWordCount;
				const isChecked = selectedCouponCode === option.value;
				return (
					<InputWrapper key={`text-radio-${name}-${option.value}-${idx}`} checked={isChecked} disabled={option.disabled}>
						<InputRadio id={`text-radio-${name}-${option.value}-${idx}`} onClick={onCouponClick} onChange={onCouponClick} name="coupon" value={option.value} checked={isChecked} disabled={option.disabled}/>
						<Toggle simple>
							{({ on, toggle }) => {
								let body = option?.display;
								if (!on && hasMore) {
									body = words.filter((_, i) => i < visibleWordCount).join(' ');
									body += '...';
								}
								return (
									<InputLabel htmlFor={`text-radio-${name}-${option.value}-${idx}`} checked={isChecked} data-display={option.display}>
										{body}
										{' '}
										{hasMore && (
											<ShowMore onClick={toggle}>
												SEE {on ? 'LESS' : 'MORE'}
											</ShowMore>
										)}
									</InputLabel>
								);
							}}
						</Toggle>
					</InputWrapper>
				);
			})}
		</CouponContainer>
	);
};

Coupons.propTypes = {
	onCouponClick: PropTypes.func,
	selectedCouponCode: PropTypes.string,
	coupons: PropTypes.arrayOf(PropTypes.shape({
		value: PropTypes.string,
		display: PropTypes.string,
	})).isRequired,
	visibleWordCount: PropTypes.number,
};

export default Coupons;
